module.exports = __webpack_public_path__ + "img/retaken.c1683cb0.svg";